import { render, staticRenderFns } from "./ListBase.vue?vue&type=template&id=0a374a4d&scoped=true&"
import script from "./ListBase.vue?vue&type=script&lang=js&"
export * from "./ListBase.vue?vue&type=script&lang=js&"
import style0 from "./ListBase.vue?vue&type=style&index=0&id=0a374a4d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a374a4d",
  null
  
)

export default component.exports